import { computed, get } from '@ember/object';

export default function ternary(dependentKey, positiveValue, negativeValue) {
  return computed(dependentKey, function () {
    return get(this, dependentKey) ? positiveValue : negativeValue;
  });
}
